import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';

import {
    BREAKPOINTS_FOR_SIX_SLIDES,
    sliderSettings
} from '../../config/slider';
import { SvgIcon } from '../../../../../../common/react/components/SvgIcon';
import { MatchCard } from './MatchCard';
import { useMatchesData } from './hooks/use-matches-data';
import { Loader } from '../../../../../../common/react/components/Loader';

export const MatchesSlider = ({ anchorName }) => {
    const sliderName = `video-hub-view-by-match-${anchorName}`;
    const data = useMatchesData();
    const compAbbreviation = useMemo(
        () =>
            PULSE.app.common.match
                .getCompAbbr(data?.[0]?.compSeason?.providerId)
                ?.toLowerCase(),
        [data]
    );

    return (
        <>
            {!data.length && (
                <div className="video-hub-view-by-match__loader">
                    <Loader />
                </div>
            )}

            <div
                className={classNames(
                    'video-hub-view-by-match__slider stats-slider fade-in-on-load',
                    { 'is-loaded': data.length }
                )}
            >
                <Swiper
                    {...sliderSettings(sliderName)}
                    {...BREAKPOINTS_FOR_SIX_SLIDES}
                >
                    {data.map((matchItem, index) => (
                        <SwiperSlide key={index}>
                            {({ isVisible }) => (
                                <MatchCard
                                    matchData={matchItem}
                                    compAbbreviation={compAbbreviation}
                                    index={index}
                                    isVisible={isVisible}
                                />
                            )}
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div
                    className={`swiper-button-prev swiper-button-prev-unique-${sliderName}`}
                >
                    <SvgIcon icon="chevron" className="icon" />
                </div>
                <div
                    className={`swiper-button-next swiper-button-next-unique-${sliderName}`}
                >
                    <SvgIcon icon="chevron" className="icon" />
                </div>
                <div className="swiper-pagination js-video-hub-view-by-match-pagination"></div>
            </div>
        </>
    );
};

MatchesSlider.propTypes = {
    anchorName: PropTypes.string.isRequired
};
